const TYPE_LABEL_MAP = {
  big: 'Modell',
  small: 'Schwester',
  one: 'Sekretär',
  two: 'Schüler',
  bi: 'Modell',
  sm: 'Schwester',
  si: 'Sekretär',
  do: 'Schüler',
  BESAR: 'Modell',
  KECIL: 'Schwester',
  GANJIL: 'Sekretär',
  GENAP: 'Schüler',
  甲: 'Modell',
  乙: 'Schwester',
  丙: 'Sekretär',
  丁: 'Schüler',
  大: 'Modell',
  小: 'Schwester',
  单: 'Sekretär',
  双: 'Schüler',
  Modell: 'Modell',
  Schwester: 'Schwester',
  Sekretär: 'Sekretär',
  Schüler: 'Schüler',
}

const TYPE_CANONICAL_MAP = {
  big: 'big',
  bi: 'big',
  BESAR: 'big',
  甲: 'big',
  大: 'big',
  Modell: 'big',
  small: 'small',
  sm: 'small',
  KECIL: 'small',
  乙: 'small',
  小: 'small',
  Schwester: 'small',
  one: 'one',
  si: 'one',
  GANJIL: 'one',
  丙: 'one',
  单: 'one',
  Sekretär: 'one',
  two: 'two',
  do: 'two',
  GENAP: 'two',
  丁: 'two',
  双: 'two',
  Schüler: 'two',
}

export function normalizeBetType(type) {
  return TYPE_CANONICAL_MAP[type] || type || ''
}

export function typeToBetLabel(type) {
  const normalized = normalizeBetType(type)
  return TYPE_LABEL_MAP[normalized] || TYPE_LABEL_MAP[type] || type || ''
}

/** 把接口返回的「甲乙丙丁」等文案换成现有单词 */
export function localizeBetText(text) {
  if (!text) return ''
  const map = {
    甲: 'Modell',
    乙: 'Schwester',
    丙: 'Sekretär',
    丁: 'Schüler',
    big: 'Modell',
    small: 'Schwester',
    one: 'Sekretär',
    two: 'Schüler',
    BESAR: 'Modell',
    KECIL: 'Schwester',
    GANJIL: 'Sekretär',
    GENAP: 'Schüler',
  }
  let out = String(text)
  Object.keys(map).forEach((k) => {
    out = out.split(k).join(map[k])
  })
  return out
}

export function getBetContent(item) {
  if (item && item.bet_content) {
    return localizeBetText(item.bet_content)
  }
  if (item && item.type) {
    return typeToBetLabel(item.type)
  }
  if (!item || !item.data || !item.data.length) {
    return ''
  }
  const rows = [...item.data].sort((a, b) => (a.id || 0) - (b.id || 0))
  return rows.map((row) => typeToBetLabel(row.type)).join('')
}

export function formatBetMoney(money) {
  const num = Number(money)
  if (Number.isNaN(num)) {
    return money
  }
  return Number.isInteger(num) ? String(num) : num.toFixed(2)
}
